import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormControl, InputLabel, Select, MenuItem, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import { toast } from 'react-toastify';
import _ from 'lodash';
import OverLoading from '../global/OverLoading';
import Constants from '../../common/constants';
import { addStaff } from '../../actions/admin/staffAction';
import { toggleModal } from '../../actions/modal';

const FormCreate = forwardRef(({ addStaff, toggleModal, updateList }, ref) => {
  const submitButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    submitForm() {
      submitButtonRef.current.click();
    },
  }));

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email:       '',
    position:    '',
    password:    '',
    permissions: {},
  });

  const { email, position, password, permissions } = formData;

  useEffect(() => {
    const tempPermissions = {};
    Constants.PermissionsInit.map((perm) => {
      _.assign(tempPermissions, { [perm]: false });
    });

    setFormData({ ...formData, permissions: tempPermissions });
  }, []);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const updatePermission = (e) => {
    setFormData({ ...formData, permissions: { ...formData.permissions, [e.target.name]: !formData.permissions[e.target.name] } });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addStaff(formData).then((response) => {
        if (response.status === 200) {
          toggleModal();
          toast.success('Staff has been added.');

          // callback
          updateList();
        } else {
          setLoading(false);
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      toast.error(err);
      setLoading(false);
    }
  };

  const findHyphen = (str) => {
    const regexp = /[\d -]+/g;
    return !!regexp.test(str);
  };

  return (
    <form
      className="form position-relative px-3"
      onSubmit={(e) => onSubmit(e)}
      autoComplete="off"
    >
      {loading && <OverLoading />}

      <div className="mb-5">
        <h4>STAFF INFO</h4>

        <FormControl style={{ width: '100%', marginBottom: 10 }}>
          <TextField type="email" id="email" label="Email" name="email" value={email} onChange={(e) => onChange(e)} />
        </FormControl>

        <FormControl style={{ width: '100%' }}>
          <InputLabel id="position-label">Position</InputLabel>
          <Select
            labelId="position-label"
            id="position"
            name="position"
            value={position}
            onChange={(e) => onChange(e)}
          >
            <MenuItem value={Constants.StaffPosition.Contractor}>{ Constants.StaffPosition.Contractor }</MenuItem>
            <MenuItem value={Constants.StaffPosition.Associate}>{ Constants.StaffPosition.Associate }</MenuItem>
            <MenuItem value={Constants.StaffPosition.Manager}>{ Constants.StaffPosition.Manager }</MenuItem>
            <MenuItem value={Constants.StaffPosition.Super}>{ Constants.StaffPosition.Super }</MenuItem>
            <MenuItem value={Constants.StaffPosition.Developer}>{ Constants.StaffPosition.Developer }</MenuItem>
            <MenuItem value={Constants.StaffPosition.Scrapper}>{ Constants.StaffPosition.Scrapper }</MenuItem>
          </Select>
        </FormControl>
      </div>

      <div className="mt-3 mb-5">
        <h4>PASSWORD</h4>
        <FormControl style={{ width: '100%' }}>
          <TextField id="password" label="Set Password" name="password" value={password} onChange={(e) => onChange(e)} />
        </FormControl>
      </div>

      <div className="mt-3 mb-5">
        <h4>PERMISSIONS</h4>
        <FormControl style={{ display: 'block', width: '100%' }}>
          {
            _.map(permissions, (value, key) => {
              if (key !== 'staff_id') {
                if (findHyphen(key)) {
                  return (
                    <p style={{
                      display:     'inline-block',
                      width:       220,
                      paddingLeft: 5,
                    }}
                    >
                      --
                    </p>
                  );
                } else {
                  return (
                    <FormControlLabel
                      key={key}
                      style={{ display: 'inline-block', width: 215 }}
                      control={<Checkbox name={key} checked={value} onChange={(e) => updatePermission(e)} />}
                      label={key}
                    />
                  );
                }
              }
            })
          }
        </FormControl>
      </div>

      <div className="form-group">
        <input
          type="submit"
          className="btn btn-primary mr-1 d-none"
          value="Save"
          ref={submitButtonRef}
        />
      </div>
    </form>
  );
});

export default connect(null, { addStaff, toggleModal }, null, {
  forwardRef: true,
})(FormCreate);
